import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ProductCardSkeletonProps {
  className?: string;
}

const ProductCardSkeleton = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div className={cn("product-card h-full flex flex-col overflow-hidden", className)}>
      {/* Image Section */}
      <div className="relative overflow-hidden aspect-square">
        <Skeleton className="w-full h-full animate-pulse" />
        
        {/* Badge placeholder */}
        <div className="absolute top-2 left-2 md:top-3 md:left-3 flex flex-col gap-1.5">
          <Skeleton className="h-5 w-16 rounded-full animate-pulse" style={{ animationDelay: '0.1s' }} />
        </div>
        
        {/* Favorite button placeholder */}
        <Skeleton 
          className="absolute top-2 right-2 md:top-3 md:right-3 h-7 w-7 md:h-8 md:w-8 rounded-full animate-pulse" 
          style={{ animationDelay: '0.15s' }} 
        />
      </div>

      {/* Content Section */}
      <div className="p-3 md:p-4 flex flex-col flex-1">
        {/* Title */}
        <Skeleton className="h-4 md:h-5 w-3/4 mb-2 animate-pulse" style={{ animationDelay: '0.2s' }} />
        <Skeleton className="h-4 md:h-5 w-1/2 mb-2 animate-pulse" style={{ animationDelay: '0.25s' }} />
        
        {/* Rating placeholder */}
        <div className="flex items-center gap-2 mb-1.5">
          <Skeleton className="h-3 w-20 animate-pulse" style={{ animationDelay: '0.3s' }} />
        </div>
        
        {/* Description */}
        <Skeleton className="h-3 w-full mb-1 animate-pulse" style={{ animationDelay: '0.35s' }} />
        <Skeleton className="h-3 w-2/3 mb-3 animate-pulse" style={{ animationDelay: '0.4s' }} />

        {/* Price and Actions */}
        <div className="flex items-end justify-between gap-2 mt-auto">
          <div>
            <Skeleton className="h-5 md:h-6 w-16 mb-1 animate-pulse" style={{ animationDelay: '0.45s' }} />
            <Skeleton className="h-3 w-10 animate-pulse" style={{ animationDelay: '0.5s' }} />
          </div>
          <div className="flex items-center gap-1">
            <Skeleton className="h-8 w-8 md:h-9 md:w-9 rounded-md animate-pulse" style={{ animationDelay: '0.55s' }} />
            <Skeleton className="h-8 w-8 md:h-9 md:w-9 rounded-md animate-pulse" style={{ animationDelay: '0.6s' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
